function ContactMe() {
  return (
    <footer>
    <div className="contact-me-container" id="contact">
      <div className="contact-me-title">
      <h1> Contact me</h1>
      </div>
      <div className="contact-me-details">
        <div className="contact-me-email">
        <a href="mailto:aromiafolabi@googlemail.com" rel="noopener noreferrer" target="_blank">
        <i class="bi bi-envelope"></i> aromiafolabi@googlemail.com 
        </a>
        </div>
        <div className="contact-me-linkedin">
        <i class="bi bi-linkedin"></i> <a href="https://www.linkedin.com/in/aromireafolabi/"> linkedin.com/in/aromireafolabi</a>
        </div>
        <div className="contact-me-github">
        <i class="bi bi-github"></i> <a href ="https://github.com/aromiafolabi">github.com/aromiafolabi</a>
        </div>
      </div>
    </div>
    </footer>
  );
}

export default ContactMe;
